
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/tutorials/test-use-write-integrate-antara",
      function () {
        return require("private-next-pages/docs/antara/tutorials/test-use-write-integrate-antara/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/tutorials/test-use-write-integrate-antara"])
      });
    }
  